var cdf = require('cdf');

if(typeof window !== 'undefined'){

  window.cdf = cdf;

  window.addEventListener('resize', function(e){
    cdf.trigger('resize',cdf,[e]);
  });

  cdf.initialized = false;

  document.addEventListener('DOMContentLoaded', function () {
    cdf.initialized = true;
    cdf.trigger('init',cdf,[cdf,cdf.animate]);
  });

} else if(typeof module !== 'undefined'){
  module.exports = cdf;
}